import { render, staticRenderFns } from "./PxCamposCompraItemSankhya.vue?vue&type=template&id=7646dea6&"
import script from "./PxCamposCompraItemSankhya.vue?vue&type=script&lang=js&"
export * from "./PxCamposCompraItemSankhya.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports